import classNames from 'classnames';
import { CSSProperties, FC } from 'react';
import styles from './styles.module.scss';

type Props = {
  className?: string;
  onClick?: VoidFunction;
  size?: number;
  tabletSize?: number;
  iconSize?: number;
  tabletIconSize?: number
  color: 'blue' | 'green';
};

const CloseButton: FC<Props> = ({ className, onClick, color, size = 73, tabletSize = 48, iconSize = 26, tabletIconSize = 20 }) => {
  const style = {
    '--size': `${size}px`,
    '--tablet-size': `${tabletSize}px`,
    '--icon-size': `${iconSize}px`,
    '--tablet-icon-size': `${tabletIconSize}px`,
  } as CSSProperties;

  return (
    <button
      className={classNames('simple-btn', styles.closeButton, { [styles[color]]: Boolean(color) }, className)}
      onClick={onClick}
      style={style}
      type="button"
    >
      <div className={styles.content}>
        <div className={classNames('ui-icon-Close', styles.icon)} />
      </div>
    </button>
  );
};

export default CloseButton;
